import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Chip,
  Stack,
  Grid,
  Paper,
  CircularProgress,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";

interface Currency {
  id: number;
  name: string;
  buy: number;
  sell: number;
  abbreviation: string;
  icon_link: string;
}

const CryptoCards: React.FC = () => {
  const [currencies, setCurrencies] = useState<Currency[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "بازار";

    const fetchCurrencies = async () => {
      try {
        const response = await fetch(
          "https://api-panel.parsianbit.com/publish/v1/currency"
        );
        const data = await response.json();
        const fetchedCurrencies = data.data.currencies.slice(0, 4); // فقط چهار ارز
        setCurrencies(fetchedCurrencies);
        setLoading(false);
      } catch (err) {
        setError("خطا در دریافت اطلاعات");
        setLoading(false);
      }
    };

    fetchCurrencies();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }} bgcolor={"background.default"}>
      <Grid container spacing={2}>
        {currencies.map((currency) => (
          <Grid item xs={12} sm={6} md={3} key={currency.id}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                borderRadius: "8px",
              }}
            >
              <Stack spacing={2}>
                {/* Header */}
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Box sx={{ display: "inline-flex", alignItems: "center" }}>
                    <img
                      src={currency.icon_link}
                      alt={currency.abbreviation}
                      width={24}
                      height={24}
                    />
                    <Typography component="span" sx={{ ml: 1 }}>
                      {currency.name} ({currency.abbreviation.toUpperCase()})
                    </Typography>
                  </Box>
                  <IconButton size="small">
                    <KeyboardBackspaceIcon />
                  </IconButton>
                </Stack>

                {/* Buy and Sell Prices */}
                <Stack direction={"column"} justifyContent={"space-between"}>
                  <Typography fontWeight="bold">
                    خرید: {currency.buy.toLocaleString()} تومان
                  </Typography>
                  <Typography sx={{ mt: 2 }} fontWeight="bold">
                    فروش: {currency.sell.toLocaleString()} تومان
                  </Typography>
                </Stack>
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CryptoCards;
